import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=06c23474&scoped=true&"
import script from "./memberDetail.vue?vue&type=script&lang=js&"
export * from "./memberDetail.vue?vue&type=script&lang=js&"
import style0 from "./memberDetail.vue?vue&type=style&index=0&id=06c23474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c23474",
  null
  
)

export default component.exports